import React, { useEffect, useRef } from "react";
import { StudentAd2Card } from "./ad2Card";
import { Utils } from "../../utilities/utils";
import { Col } from "react-bootstrap";
import { FutureOfWorkSpeedometer } from "./futureOfWorkSpeedometer";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { updateImageBase } from "./imageReducer";
import html2canvas from "html2canvas";

export function Ad2FutureOfWork({ data, onViewMoreClick }) {
  const chartData = data;
  const status = chartData && chartData.status;
  const total = chartData && chartData.totalScore;
  const cognitive = chartData && chartData?.domains?.Cognitive;
  const digital = chartData && chartData?.domains?.Digital;
  const selfLeadership = chartData && chartData?.domains?.['Self Leadership'];
  const dispatch = useDispatch();
  const interpersonal = chartData && chartData?.domains?.Interpersonal;
  const getLabels = (arr) => {
    return Utils.getLabels(arr).map(value => {
      return value.charAt(0).toUpperCase() + value.slice(1);
    })
  }
  const labelsSet1 = [...new Set([...getLabels(cognitive), ...getLabels(digital)])];
  const labelsSet2 = [...new Set([...getLabels(selfLeadership), ...getLabels(interpersonal)])];
  const { t, i18n } = useTranslation();
  const cardsData = [
    {
      title: t("Cognitive"),
      value: chartData && chartData?.domains?.["Cognitive"] && chartData?.domains?.["Cognitive"]?.points,
    },
    {
      title: t("Digital"),
      value: chartData && chartData?.domains?.["Digital"] && chartData?.domains?.["Digital"]?.points,
    },
    {
      title: t("Self Leadership"),
      value: chartData && chartData?.domains?.["Self Leadership"] && chartData?.domains?.["Self Leadership"]?.points,
    },
    {
      title: t("Interpersonal"),
      value: chartData && chartData?.domains?.["Interpersonal"] && chartData?.domains?.["Interpersonal"]?.points,
    },
  ];
  //  const chartRef = useRef(null);
  const chartRef = useRef(null);
  const chartRef2 = useRef(null);
  const chartRef3 = useRef(null);
  const chartRef4 = useRef(null);

  const refList = [chartRef, chartRef2, chartRef3, chartRef4]
  useEffect(() => {
    if (data && data.domains) {
      setTimeout(() => {
        refList.forEach((ref, index) => {
          html2canvas(ref.current, { backgroundColor: null, scale: 2 }).then((canvas) => {
            const ctx = canvas.getContext("2d");
            const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);

            let top = null, bottom = null, left = null, right = null;
            for (let y = 0; y < imgData.height; y++) {
              for (let x = 0; x < imgData.width; x++) {
                const alpha = imgData.data[(y * imgData.width + x) * 4 + 3];
                if (alpha > 0) {
                  if (top === null) top = y;
                  bottom = y;
                  if (left === null || x < left) left = x;
                  if (right === null || x > right) right = x;
                }
              }
            }

            const trimmed = ctx.getImageData(left, top, right - left, bottom - top);
            const newCanvas = document.createElement("canvas");
            newCanvas.width = right - left;
            newCanvas.height = bottom - top;
            newCanvas.getContext("2d").putImageData(trimmed, 0, 0);

            const base64 = newCanvas.toDataURL("image/png");

            dispatch(updateImageBase({
              name: "futureOfWork" + (index + 1),
              value: base64
            }));
          });
        })



      }, 500); // wait a bit for charts to render
    }
  }, [data]);

  return <>
    <StudentAd2Card title={t("The Future Of Work")} status={status} onViewMoreClick={onViewMoreClick}>
      {
        cardsData.map((item, index) =>

          <Col md="6" key={index}>
            <div ref={refList[index]}>
              <FutureOfWorkSpeedometer {...item} />
            </div>
          </Col>

        )
      }
    </StudentAd2Card>
  </>;
}